<template>
	<div class="card card-accent-success mb-3">
		<div class="card-header px-3 py-2">
			<i class="far fa-list-alt fa-lg mr-2"></i>
			{{ __('translations.title.general_info') }}
		</div>
		<div class="card-body p-3">
			<div v-if="success" class="alert alert-success">
				{{ __('translations.message.saved') }}
			</div>
			<form @submit.prevent="save" autocomplete="off">
				<input type="hidden" name="page_id" id="page" v-model="page.id" />
				
				<div class="form-group row">
					<label for="title" class="col-sm-4 col-form-label col-form-label-sm pr-0">{{ __('translations.label.page_type') }}</label>
					<div class="col-sm-8">
						<select class="form-control form-control-sm" id="page_type" v-model="page.page_type">
					      <option value=""></option>
					      <option value="FRONT_PAGE">{{ __('translations.page_type.front_cover') }}</option>
					      <option value="BACK_PAGE">{{ __('translations.page_type.back_cover') }}</option>
					      <option value="EMPTY_PAGE">{{ __('translations.page_type.empty_page') }}</option>
					    </select>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-4 pr-0"></div>
					<div class="col-sm-8">
						<button type="submit" class="btn btn-sm btn-success">{{ __('translations.button.save') }}</button>
						<button type="button" class="btn btn-sm btn-secondary ml-2" @click="cancel">{{ __('translations.button.cancel') }}</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import FormMixin from '../mixins/FormMixin';

export default {
	name: 'PageInfo',
	mixins: [FormMixin],
	props: ['page'],
	data() {
		return {
			action: '/savePageInfo',
		}
	},
	mounted() {
		// Keep track of the original image information
		this._beforeEditingCache = Object.assign({}, this.page);
	},
	methods: {
		save() {
			this.fields.page_id = this.page.id;
			this.fields.page_type = this.page.page_type;

			this.submit();

			// TODO: Cache it only if the saving was successful
			// Keep track of the updated page information
			this._beforeEditingCache = Object.assign({}, this.page);
		},
		cancel() {
			// Return the page data back to its previous state
			Object.assign(this.page, this._beforeEditingCache);
		}
	}
}
</script>